<sbnb-apps-detail-page
  vendorCode="ruebarue"
  name="RueBaRue"
  logoTile="/assets/images/apps/ruebarue.png"
  builtBy="RueBaRue"
  [categories]="['Guestbook', 'Guest Communication', 'Operations']"
  [permissions]="[AppPermission.propertyListingRead, AppPermission.reservationRead, AppPermission.calendarRead]"
  email="support@ruebarue.com"
  [helpArticles]="[
    { id: '11029559', title: 'Connect Hospitable with RueBaRue to Streamline Guest Communication and Operations' }
  ]">
  <ng-container description>
    <div>
      <h3 class="mt-4">RueBaRue + Hospitable Integration</h3>

      <p>
        Most vacation rental managers use digital guestbooks to share check-in details and house rules—but did you know
        they can do so much more? A well-optimized guestbook can reduce guest inquiries, boost add-on sales, and enhance
        the guest experience with minimal effort.
      </p>

      <p>
        With RueBaRue's integration with Hospitable, your guest communication is fully automated—so every guest receives
        your digital guestbook via text or email without lifting a finger. You'll eliminate repetitive questions,
        improve response times, and free up hours of your team's time.
      </p>

      <p>Here's what you can do with RueBaRue:</p>

      <h3>Digital Guestbooks</h3>

      <strong>Automate Guest Communication</strong>
      <p>
        Send your guestbook automatically via text or email before arrival. No more last-minute “Where's the WiFi?”
        messages.
      </p>

      <strong>Clear Instructions with Photos & Videos</strong>
      <p>
        Help guests use TVs, hot tubs, or smart locks with step-by-step guides and videos—reducing confusion and support
        calls.
      </p>

      <strong>Set House Rules & Expectations</strong>
      <p>Avoid misunderstandings by clearly outlining quiet hours, pet policies, and emergency contacts.</p>

      <strong>Promote Local Recommendations</strong>
      <p>Offer more than just listings—add affiliate links or exclusive discounts to local restaurants and tours.</p>

      <strong>Interactive Maps</strong>
      <p>Make it easy for guests to explore with embedded maps featuring local attractions and dining spots.</p>

      <strong>Real-Time Updates</strong>
      <p>Instantly update your guestbook to reflect weather alerts, road closures, or new recommendations.</p>

      <strong>Upsell Add-Ons</strong>
      <p>Offer early check-in, late checkout, and paid local experiences directly from the guestbook.</p>

      <strong>Encourage 5-Star Reviews</strong>
      <p>Include a friendly link to your Airbnb, Vrbo, or Google review page at the end of each stay.</p>

      <strong>Reduce Guest Inquiries</strong>
      <p>Troubleshooting guides, FAQs, and clear instructions help guests help themselves.</p>

      <h3>Text Messaging Tools</h3>

      <strong>Text Automation</strong>
      <p>
        Automatically send texts before and during a guest's stay to deliver essential info and personalized service.
      </p>

      <strong>Unified Inbox</strong>
      <p>Get a dedicated team text line. Manage all guest and owner texts in one shared inbox.</p>

      <strong>Text Webchat</strong>
      <p>Turn website chats into text conversations. Capture leads even when you're away from your desk.</p>

      <strong>Emergency Alerts</strong>
      <p>Notify guests of weather events, outages, or road closures with urgent, scheduled text alerts.</p>

      <strong>Extend Guest Stays</strong>
      <p>Automatically identify and fill gap nights by texting guests with early check-in or late checkout offers.</p>

      <strong>Google Review Requests</strong>
      <p>Prompt happy guests to leave reviews via automated post-stay texts.</p>

      <strong>Guest Surveys</strong>
      <p>Gather feedback with short, mobile-friendly surveys sent before, during, or after the stay.</p>

      <strong>AI Assistant</strong>
      <p>Use AI to craft smart replies, schedule messages, or generate alerts with just a few clicks.</p>

      <p>
        Whether you manage 2 properties or 500, RueBaRue gives your team powerful tools to enhance the guest experience,
        reduce support calls, and grow revenue—all while saving time. reservations.
      </p>
      <sbnb-image-carousel
        [images]="[
          '/assets/images/apps/rue-ba-rue/image1.png',
          '/assets/images/apps/rue-ba-rue/image2.png',
          '/assets/images/apps/rue-ba-rue/image3.png',
          '/assets/images/apps/rue-ba-rue/image4.png',
          '/assets/images/apps/rue-ba-rue/image5.png',
          '/assets/images/apps/rue-ba-rue/image6.png'
        ]"></sbnb-image-carousel>
    </div>
  </ng-container>
</sbnb-apps-detail-page>
